// DS2.5
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../PlainButtonOrLink';
import { IconSize } from '../../Icons/IconWrap';
import SimpleTooltip from '../../tooltips/dsPreset/SimpleTooltip';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import s from './IconButton.scss';
const IconButton = (_param)=>{
    var { size, iconSizeOverride, iconClassName, className, icon: IconComponent, variant = 'main', tooltipText, tooltipOffset, tooltipHoverDelay, iconStyle } = _param, props = _object_without_properties(_param, [
        "size",
        "iconSizeOverride",
        "iconClassName",
        "className",
        "icon",
        "variant",
        "tooltipText",
        "tooltipOffset",
        "tooltipHoverDelay",
        "iconStyle"
    ]);
    const { device } = useContext(SessionContext);
    const iconSizes = {
        small: IconSize.SMALLER,
        medium: IconSize.MEDIUM,
        large: IconSize.MEDIUM
    };
    const icon = /*#__PURE__*/ React.createElement(IconComponent, {
        className: classnames(s['icon'], iconClassName),
        size: iconSizeOverride || iconSizes[size],
        disableDefaultColors: true,
        style: iconStyle
    });
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        className: classnames(s['root'], s[`size-${size}`], variant && s[`variant-${variant}`], props.disabled && s['disabled'], props.loading && s['loading'], className)
    }, props), !(device === null || device === void 0 ? void 0 : device.isMobileDevice) && tooltipText ? /*#__PURE__*/ React.createElement(SimpleTooltip, {
        usePortal: true,
        text: tooltipText,
        offsetModifier: tooltipOffset,
        hoverDelay: tooltipHoverDelay,
        listenOnClicks: false
    }, icon) : icon);
};
IconButton.displayName = 'IconButton';
export default IconButton;

//# sourceMappingURL=IconButton.js.map